import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import Sortable from "sortablejs";
import { Image } from "../../../AbstractElements";
import { StackableTreeView } from "../../../Constants/Constants";
import { StackableTreeData } from "../../../Data/BonusUi/Tree";
import { SortableItem, SortableSwapListType } from "../../../Types/BonusUiType";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SortableSwapList: React.FC<SortableSwapListType> = ({ items }) => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      const initSortable = (element: HTMLElement) => {
        Sortable.create(element, {
          group: "shared",
          animation: 150,
          handle: ".sortable-handle",
        });
        Array.from(element.querySelectorAll(".list-group")).forEach((el) => {
          initSortable(el as HTMLElement);
        });
      };
      initSortable(listRef.current);
    }
  }, []);

  const renderItems = (items: SortableItem[]) => (
    <ListGroup>
      {items.map((item) => (
        <ListGroupItem key={item.id} className="nested-1 sortable-item">
          <div className="sortable-handle">
            <Image src={dynamicImage(item.image)} alt="" className="me-2"/> {item.content}
          </div>
          {item.children && renderItems(item.children)}
        </ListGroupItem>
      ))}
    </ListGroup>
  );

  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={StackableTreeView} span={StackableTreeData} />
        <CardBody className="swap-wrapper">
          <ul className="list-group p-0" ref={listRef} id="sortable-swap">
            {renderItems(items)}
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SortableSwapList;
